/**
 * Profile Query Keys for AmalQ
 * Centralized query key management for profile-related queries
 * Following TanStack Query best practices
 */

import { SectionCompletionQuery } from '../types/profile.types';

export const profileQueryKeys = {
  all: ['profile'] as const,
  profile: () => [...profileQueryKeys.all, 'profile'] as const,
  completion: () => [...profileQueryKeys.all, 'completion'] as const,
  enhancedCompletion: (query?: SectionCompletionQuery) => [...profileQueryKeys.all, 'enhancedCompletion', query] as const,
  sectionCompletion: (section: string) => [...profileQueryKeys.all, 'sectionCompletion', section] as const,
  verificationStatus: () => [...profileQueryKeys.all, 'verificationStatus'] as const,
} as const;
